const initialState = {
    activeProjet: null,
    listProjets: [],
}

const projetClientReducer = (state = initialState, action) => {
    switch(action.type){
        case "SET_ACTIVE_PROJET":
            return { ...state, activeProjet: action.payload };
        case "SET_PROJETS_CLIENTS":
            return { ...state, listProjets: action.payload };
        default:
            return state;

    }
}
export default projetClientReducer;